"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceAware__factory = void 0;
var ethers_1 = require("ethers");
var PriceAware__factory = /** @class */ (function (_super) {
    __extends(PriceAware__factory, _super);
    function PriceAware__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PriceAware__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PriceAware__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PriceAware__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PriceAware__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PriceAware__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return PriceAware__factory;
}(ethers_1.ContractFactory));
exports.PriceAware__factory = PriceAware__factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newSigner",
                type: "address",
            },
        ],
        name: "TrustedSignerChanged",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_trustedSigner",
                type: "address",
            },
        ],
        name: "authorizeSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "maxDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_maxDelay",
                type: "uint256",
            },
        ],
        name: "setMaxDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "trustedSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=PriceAware__factory.js.map